import React from 'react';

import {
  CaseBenefitsTabContent,
  CASE_BENEFIT_EM_TAG_CLOSE,
  CASE_BENEFIT_EM_TAG_OPEN,
  CASE_BENEFIT_SPECIAL_SPACE_CHARACTER,
} from '../case-benefits-tab-content';

const EM_TAG_OPEN = CASE_BENEFIT_EM_TAG_OPEN;
const EM_TAG_CLOSE = CASE_BENEFIT_EM_TAG_CLOSE;
const SPECIAL_SPACE_CHARACTER = CASE_BENEFIT_SPECIAL_SPACE_CHARACTER;

export const Case3BenefitsTabContent = React.memo(() => {
  const Case3Benefits = React.useMemo<string[]>(() => {
    const case1Benefits: string[] = [
      `${EM_TAG_OPEN}93%${SPECIAL_SPACE_CHARACTER}reduction${EM_TAG_CLOSE} in order fallout`,
      `${EM_TAG_OPEN}50%${SPECIAL_SPACE_CHARACTER}reduction${EM_TAG_CLOSE} in customer complaints related to SIM activation`,
      `${EM_TAG_OPEN}50%${SPECIAL_SPACE_CHARACTER}reduction${EM_TAG_CLOSE} in time to resolve mediation and billing issues`,
    ];

    return case1Benefits;
  }, []);

  return <CaseBenefitsTabContent items={Case3Benefits} />;
});
